const ReportsModule = {
  namespaced: true,

  state: {
    billData: { html: "", css: "" },
    xlsData: { items: [], headers: [], title: "", landscape: false },
    tableData: { items: [], headers: [], title: "", landscape: false },
    dailyReport: { items: [], headers: [], title: "", landscape: false },
    summeryReport: { items: [], headers: [], title: "", landscape: false }
  },

  getters: {
    billData: state => state.billData,
    xlsData: state => state.tableData,
    tableData: state => state.tableData,
    dailyReport: state => state.dailyReport,
    summeryReport: state => state.summeryReport
  },

  mutations: {
    setXlsData(state, data) {
      state.xlsData = data;
    },

    setTableData(state, data) {
      state.tableData = data;
    },

    setBillData(state, data) {
      state.billData = data;
    },

    setDailyReport(state, data) {
      state.dailyReport = data;
    },

    setSummeryReport(state, data) {
      state.summeryReport = data;
    }
  }
};

export default ReportsModule;
